<template>
    <div>
        <el-select @change="kqdataChange" style="width: 150px;margin-left: 20px;flex:1" size="mini" v-model="kqdata" slot="prepend" placeholder="请选择">
            <el-option v-for="val in kaoqinList" :key="val.i_id" :label='val.vc_tcname' :value="val.vc_tcname"></el-option>
        </el-select>
        <div class="tree gdheight mrt10" id="gdtree">
            <el-tree
                    ref="tree"
                    :data="treeData"
                    lazy
                    :load="loadNode"
                    :props="defaultProps"
                    node-key="value"
                    @node-click="handleNodeClick"
                    class="trees  video-tree height100"
                    accordion
                    :highlight-current='true'
                    :expand-on-click-node="false">

            </el-tree>
        </div>
    </div>
</template>

<script>
    import * as API from "./../workManage/api"
    import {mapActions} from "vuex";

    export default {
        name: "index",
        components: {},
        data() {
            return {
                defaultProps: {
                    children: 'children',
                    label: 'label',
                    isLeaf: 'isLeaf'
                },
                expanded:[],
                treeData:[],
                kaoqinList:[],
                kaoqini_id:0,
                kqdata:'',
            }
        },
        watch:{

        },
        mounted() {
            this.getKqList()
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            //考勤方案接口
            async getKqList() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                // console.log("result",result)
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param = {
                    i_mid: this.mid,
                };
                let res = await API.getKqList(param);
                if (res.code == 1) {
                    this.kaoqinList=res.data
                    this.kqdata=res.data[0].vc_tcname
                    let kqdjmark=this.kaoqinList.filter(item=>{
                        return item.vc_tcname==this.kqdata
                    })
                    this.kaoqini_id=kqdjmark[0].i_id
                    this.djmark=kqdjmark[0].vc_djmark
                    this.$emit('showData','',this.kaoqini_id,this.djmark)
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //考勤下拉框
            kqdataChange(val){
                console.log(val,'-------')
                this.kqdata=val
                let kqdjmark=this.kaoqinList.filter(item=>{
                    return item.vc_tcname==val
                })
                this.djmark=kqdjmark[0].vc_djmark
                this.kaoqini_id=kqdjmark[0].i_id
                this.currentPage=1
                // this.$refs.tree.updateKeyChildren()
                this.node.childNodes=[]
                this.loadNode(this.node,this.resolve)
                this.$emit('showData','',this.kaoqini_id,this.djmark)
                // this.$refs.tree.$children[0].refresh()
                // console.log(this.$refs.tree,'this.$refs.tree.$children[0]')
                // this.records()
                // this.time()

                // console.log(kqdjmark)
            },
            async getDeptTree({value=0,type='depart'},resolve){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                // console.log("result",result)
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param = {
                    i_mid: this.mid,
                    id:value,
                    type:type,
                    i_kqtcid:this.kaoqini_id
                };
                let res = await API.departTree(param);
                if (res.code == 1) {


                    let list=[];
                    if (res.data.length>0){
                        res.data.map(one=>{
                            let hash={
                                label:one.name,
                                value:one.id,
                                type:one.type,
                                isLeaf: one.type=='depart'?false:true,
                            };
                            list.push(hash);
                        })
                    }
                    // console.log(list,'tree')
                    // if (pid!=0){
                    return resolve(list);
                    // }else {
                    //     this.treeData=list
                    // }

                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            handleNodeClick(val){
                // console.log(val,'treeData')
                this.$emit('showData',val,this.kaoqini_id)


            },
            loadNode(node, resolve) {
                // console.log(this.treeData,'treeData');
                let _this=this;
                if (node.level === 0) {
                    _this.node=node
                    _this.resolve=resolve
                    let val={
                        value:0,
                        i_level:1,
                        i_state:0,

                    }
                    setTimeout(() => {
                        _this.getDeptTree(val,resolve);
                    }, 100)
                }
                if (node.level>=1&&node.data.isLeaf==false){
                    _this.getDeptTree(node.data,resolve);
                }
            },
            // loadNode(node, resolve) {
            //     if (node.level === 0) {
            //         return resolve([{ vc_name: '全部' }]);
            //     }
            //     if (node.level > 2) return resolve([]);
            //     let i=0
            //     setTimeout(() => {
            //         i++
            //         const data =this.treeData[i].children;
            //         resolve(data);
            //     }, 500);
            // }
        }
    }
</script>

<style lang="scss" scoped>
    /deep/.el-tree-node__label{
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>